import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { CronDisplayPipe } from '@iot-platform/pipes';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-cron-readable-cell',
  templateUrl: './cron-readable-cell.component.html',
  imports: [CronDisplayPipe],
  providers: [CronDisplayPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cron-readable-cell.component.scss']
})
export class CronReadableCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<ICellRendererParams> = signal(null);

  agInit(params: ICellRendererParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
